<template>
<v-dialog v-model="dialog" max-width="800px">
	<v-card class="elevation-12">
		<v-toolbar
			color="primary"
			dark
			flat>
			<v-toolbar-title>Approve Registration</v-toolbar-title>
		</v-toolbar>
		<v-card-text>
			<Preloader text="Loading" v-if="loading" />

      <v-tabs v-if="!loading && registration">
        <v-tab>Information</v-tab>
        <v-tab>Identification</v-tab>
        <v-tab>Birth Cert.</v-tab>
        <v-tab-item>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                label="Firstname"
                prepend-icon="mdi-account"
                v-model="registration.firstname"
                readonly/>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field 
                v-model="registration.middlename" 
                prepend-icon="mdi-account"
                label="Middlename"
                readonly=""/>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field 
                v-model="registration.lastname" 
                prepend-icon="mdi-account"
                label="Lastname"
                readonly/>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                label="Birthdate"
                prepend-icon="mdi-calendar"
                v-model="registration.birthdate"
                readonly/>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Email"
                prepend-icon="mdi-email"
                v-model="registration.email"
                readonly/>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Mobile"
                prepend-icon="mdi-phone"
                v-model="registration.mobile"
                readonly/>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Address"
                prepend-icon="mdi-map-marker"
                v-model="registration.address"
                readonly/>
            </v-col>
          </v-row>

          <div class="text-center mt-n4">
            <v-btn color="primary" @click="editDetails">
              <v-icon left small>
                mdi-pencil
              </v-icon>
              Edit Details
            </v-btn>
          </div>
        </v-tab-item>

        <v-tab-item>
          <v-img :src="getUploadUrl(registration, 'identificationUpload.location', 0)"></v-img>
          <div class="text-center mt-2">
            <v-btn :href="getUploadUrl(registration, 'identificationUpload.location', 0)" target="_blank">
              Full Image
            </v-btn>
          </div>
        </v-tab-item>

        <v-tab-item>
          <v-img :src="getUploadUrl(registration, 'birthcertUpload.location', 0)"></v-img>
          <div class="text-center mt-2">
            <v-btn :href="getUploadUrl(registration, 'birthcertUpload.location', 0)" target="_blank">
              Full Image
            </v-btn>
          </div>
        </v-tab-item>
      </v-tabs>


      <v-row v-if="!loading && registration">
        <v-col cols="12">
          <v-text-field
            label="In case of rejection, specify reason below:"
            placeholder="Reason"
            prepend-icon="mdi-close"
            hint="Ex. Invalid Identification Card"
            v-model="registration.remarks"/>
        </v-col>
      </v-row>
		</v-card-text>
		<v-card-actions>
			<v-btn 
				color="blue" dark
				@click="restore()"
				v-show="!( loading || !isProcessed(registration) )">
				Restore
			</v-btn>
			<v-btn 
				color="red" dark
				@click="reject()"
				v-show="!( loading || isProcessed(registration) )">
				Reject
			</v-btn>
			<v-spacer />
			<v-btn 
				@click="dialog = false">
				Close
			</v-btn>
			<v-btn 
				color="primary" dark
				@click="approve()"
				v-show="!( loading || isProcessed(registration) )">
				Approve
			</v-btn>
			<v-btn 
				color="red" dark
				@click="cancelEnrollment()"
				v-show="!( loading || !isEnrolled(registration) )">
				Cancel
			</v-btn>
		</v-card-actions>
  </v-card>
	
</v-dialog> 
</template>
<script>
import Auth from '../../services/auth'
import Api from '../../services/api'
import Constants from '../../services/constants'
import Notify from '../../services/notify'
import Preloader from '../main/Preloader'

export default {
  name: 'ApprovalForm',
  components: { Preloader },
  data() {
    return {
      loading: false,
      dialog: false,
      registration: null, 
    }
  },
  methods: {
    init(registration) {
      this.dialog = true;
      this.loading = true;
      Api.registration.get(registration.id)
        .then((response) => {
          this.registration = response.data;
          this.registration.firstname = this.registration.firstname + ' ' + (this.registration.extname || '');
          this.registration.address = 
            this.registration.province + ', ' +
            this.registration.city + ', ' +
            this.registration.street;
        })
        .finally(() => { this.loading = false; });
    },

    approve() {
      Notify.confirm('Approve Registration?', "This will notify the applicant through email. This will also send an examination link if the applicant is applying for Diploma Programs.")
        .then(() => {
          this.loading = true;
          Api.registration.approve(
            this.registration.id,
            Auth.getLoggedUser().id
          )
            .then(() => {
              Notify.toast('Application approved!');
              this.$emit('registration-approved');
            })
            .catch(() => {
              Notify.toast('Oops, Something went wrong..');
            })
            .finally(() => {
              this.dialog = false;
              this.loading = false;
            });
        })
        .catch(() => {});
    },

    reject() {
      if(!this.registration.remarks) {
        Notify.toast('Specify reason first');
        return;
      }

      Notify.confirm('Reject Registration?', "This will notify the applicant through email.")
        .then(() => {
        this.loading = true;
          Api.registration.reject(
              this.registration.id,
              Auth.getLoggedUser().id,
              this.registration.remarks
            )
            .then(() => {
              this.loading = false;
              this.dialog = false;
              Notify.toast('Application rejected');
              this.$emit('registration-rejected');
            });
        }).catch(() => {});
    },

    restore() {
      Notify.confirm('Restore Registration?', "This will remove the approval, enroll and rejection status of this registration.")
        .then(() => {
          this.loading = true;
          Api.registration.restore({
            id: this.registration.id,
          })
            .then(() => {
              Notify.toast('Application restored!');
              this.$emit('registration-restored');
            })
            .catch(() => {
              Notify.toast('Oops, Something went wrong..');
            })
            .finally(() => {
              this.dialog = false;
              this.loading = false;
            });
        })
        .catch(() => {});
    },

    cancelEnrollment() {
      Notify.confirm('Cancel Enrollment?', "This will notify the applicant through email.")
        .then(() => {
          this.loading = true;
          Api.registration.cancel(this.registration.id, Auth.getLoggedUser().id)
            .then(() => {
              this.dialog = false;
              Notify.toast('Enrollment cancelled!');
              this.$emit('registration-cancelled');
            })
            .catch(() => { Notify.error.oops() });
        })
        .catch(() => {})
        .finally(() => { this.loading = false; });
    },    

    getUploadUrl(registration, objectName, rawMode) {
      let location =  registration[objectName];
      if(rawMode && location) {
        let locations = location.split('.');

        if(locations.length >= 2) {
          location = locations[0] + '_raw.' + locations[1];
        }
      }
      return Constants.UPLOAD_URL + '/' + location;
    },

    editDetails() {
      this.$emit('update-registration', this.registration);
      this.dialog = false;
    },

    isProcessed(registration) {
      if(!registration) {
        return false;
      }
      return registration.approveDateTime != null 
          || registration.rejectDateTime != null
          || registration.enrollDateTime != null;
    },

    isEnrolled(registration) {
      if(!registration) {
        return false;
      }
      return registration.enrollDateTime != null;
    },

    isAdmin() {
      return Auth.isType(Constants.USER.ADMIN);
    }
  }
}
</script>